import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { NgxPermissionsService } from "ngx-permissions";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserLogin } from "../../user-management/models/user-login.model";
import { User } from "../../user-management/models/user.model";
import { RolePermissionService } from "../../user-management/services/role-permission.service";
import { UserService } from "../../user-management/services/user.service";
import * as Bowser from "bowser";
import { AppService } from "src/app/global/services/app.service";

declare const $: any;

@Injectable({ providedIn: "root" })
export class AuthService {
  public TokenLogin: string;

  private storageUserKey: string = "currentUser";
  private storageTokenKey: string = "jwt";
  private storageRefreshTokenKey: string = "refreshJwt";
  private storagePermissionKey: string = "currentPermissions";
  private currentUserSubject: BehaviorSubject<User | null> =
    new BehaviorSubject<User | null>(null);
  private currentPermissionSubject: BehaviorSubject<Map<string, string[]>> =
    new BehaviorSubject<Map<string, string[]>>(null);
  private currentJWTSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);
  private currentRefreshJWTSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);

  deviceIdentifier: string;

  constructor(
    private _appService: AppService,
    private jwtHelper: JwtHelperService,
    private userService: UserService,
    private router: Router,
    private permissionsService: NgxPermissionsService,
    private rolePermissionService: RolePermissionService //private fcmService: FirebaseMessagingService
  ) {
    this.getJWT();
    this.setDeviceIdentifier();
    // User
    let userJson: string | null = localStorage.getItem(this.storageUserKey);
    if (userJson != null) {
      this.currentUserSubject.next(JSON.parse(userJson));
      //this.fcmService.updateNotifications(this.currentUserSubject?.value?.id);

      // JWT
    }

    // Permissions
    let permissionsJson: string | null = localStorage.getItem(
      this.storagePermissionKey
    );
    if (permissionsJson != null) {
      this.currentPermissionSubject.next(JSON.parse(permissionsJson));
      this.setPermissions(this.currentPermissionsValue);
      // this.currentPermissionsValue = JSON.parse(permissionsJson);
    }
  }

  //#region Usados

  setToken(token: string) {
    localStorage.setItem("jwt", token);
  }

  async getJWT() {
    this.TokenLogin = localStorage.getItem("jwt");
  }

  public get currentUserSubs() {
    return this.currentUserSubject;
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  public set currentUserValue(user: User) {
    if (user == null) {
      return;
    }
    localStorage.setItem(this.storageUserKey, JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  public get currentPermissionsValue(): Map<string, string[]> {
    return this.currentPermissionSubject.value;
  }

  public set currentPermissionsValue(permissions: Map<string, string[]>) {
    if (permissions == undefined) {
      return;
    }

    localStorage.setItem(
      this.storagePermissionKey,
      JSON.stringify(permissions)
    );
    this.currentPermissionSubject.next(permissions);

    this.setPermissions(permissions);
  }

  private setPermissions(permissions: Map<string, string[]>) {
    this.permissionsService.flushPermissions();

    for (let key of Object.keys(permissions)) {
      this.permissionsService.addPermission(key);
      let values: string[] = permissions[key];
      values.forEach((val) => {
        this.permissionsService.addPermission(`${key}.${val}`);
      });
    }
  }

  setDeviceIdentifier() {
    // Device
    const browser = Bowser.getParser(window.navigator.userAgent);
    this.deviceIdentifier = `${browser.getBrowserName()} - ${browser.getOSName()}${browser.getOSVersion()}`;
  }

  updateCurrentUser(user: User) {
    if (user == undefined) return;
    this.currentUserValue = user;
  }

  updateCurrentUserPermissions() {
    if (this.currentUserValue.roleID == undefined) return;
    this.rolePermissionService
      .getFrontEndPermissions<Map<string, string[]>>(
        this.currentUserValue.roleID
      )
      .toPromise()
      .then(
        (res) => {
          this.currentPermissionsValue = res;
        },
        (error: HttpErrorResponse) => console.log(error)
      );
  }

  login(body: {
    email: string;
    password: string;
    deviceIdentifier: string;
  }): Observable<User> {
    try {
      if (!this.deviceIdentifier) {
        this.setDeviceIdentifier();
      }

      if (!body.deviceIdentifier) {
        body.deviceIdentifier = this.deviceIdentifier;
      }

      return this.userService.login<UserLogin>(body).pipe(
        map((response) => {
          // User and Permissions
          this.currentUserValue = response.user;
          this.currentPermissionsValue = response.permissions;
          this.setToken(response.token);
          this.getJWT();
          this._appService.init();
          this.router.navigateByUrl("/dashboard");
          //this.fcmService.updateNotifications(this.currentUserSubject.value.id);

          return this.currentUserSubject.value;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  logout() {
    console.info("[logout] ejecutado");
    this.removeStorage();

    /*if (this.currentRefreshJWTValue == null) {
      this.removeStorage();
      return;
    }

    this.userService.revokeToken(this.currentRefreshJWTValue).toPromise().then(res => {
      this.removeStorage();
    }, error => {
      console.log(error);
      this.removeStorage();
    });*/
  }

  removeStorage() {
    console.info("[removeStorage] ejecutado");

    localStorage.removeItem("currentUser");
    localStorage.removeItem("jwt");
    localStorage.removeItem("currentPermissions");
    localStorage.removeItem("shelter");
    localStorage.removeItem("corporate");
    localStorage.removeItem("plant");

    this.currentUserSubject.next(null);
    this.currentPermissionSubject.next(null);
    this.currentJWTSubject.next(null);

    this.router.navigateByUrl("/login");
  }

  public async interceptorJWT(): Promise<string> {
    await this.getJWT();

    if (this.TokenLogin == "" || this.TokenLogin == null) {
    } else if (this.jwtHelper.isTokenExpired(this.TokenLogin)) {
      await this._appService.SweetAlert.showConfirm(
        "Your session has expired",
        "you need login again",
        "info",
        false
      );
      this.logout();
    } else {
      return this.TokenLogin;
    }
  }
}
